import React from 'react';
import IndexSkeleton from '../IndexSkeleton';
import {getTheme} from '@ey/styled-theme';
import styled, {ThemeProvider} from 'styled-components';
import {getTheme as utilsGetTheme} from '../../utils/utils';

function LoaderContainer(props) {
	const {isLoading, children} = props;

	const theme = utilsGetTheme();

	return (
		<ThemeProvider theme={getTheme(theme)}>
			<StyledAppContainer>{isLoading ? <IndexSkeleton /> : children}</StyledAppContainer>
		</ThemeProvider>
	);
}

export default LoaderContainer;

const StyledAppContainer = styled.section`
	background: var(--neutrals-25);
	height: 100%;
	overflow: hidden;
	.react-loading-skeleton {
		background-color: var(--neutrals-200);
		background-image: var(--neutrals-100);
		background-size: 200px 100%;
		display: inline-block;
		line-height: 1;
		width: 100%;
		background-repeat: no-repeat;
		border-radius: 4px;
		animation: 1.2s ease-in-out 0s infinite normal none running animation-16jpnkj;
	}
	.fetch-loader {
		.motif-loader-container {
			z-index: 999;
			background-color: var(--neutrals-25);
		}
	}
`;
